import PropTypes from 'prop-types';
import './Card.css';

/**
 * Reusable Card component with consistent styling
 */
export default function Card({
  children,
  title,
  subtitle,
  header,
  footer,
  className = '',
  padding = true,
  shadow = true,
  ...props
}) {
  return (
    <div
      className={`card-custom ${shadow ? 'card-shadow' : ''} ${className}`.trim()}
      {...props}
    >
      {(title || subtitle || header) && (
        <div className="card-header">
          {header || (
            <>
              {title && <h3 className="card-title">{title}</h3>}
              {subtitle && <p className="card-subtitle">{subtitle}</p>}
            </>
          )}
        </div>
      )}
      <div className={`card-body ${padding ? 'card-padding' : ''}`.trim()}>
        {children}
      </div>
      {footer && <div className="card-footer">{footer}</div>}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
  padding: PropTypes.bool,
  shadow: PropTypes.bool,
};

